<div class="horizontal-center-layout display-flex">
  <sh-icon
    icon="arrow-line-left-s"
    button
    class="carousel-button carousel-button--left"
    tabindex="0"
    size="m"
    [disabled]="!hasItemsOnLeft()"
    (click)="scrollLeft()"
    onkeyup="scrollLeft()"
  ></sh-icon>

  <div class="carousel-container">
    <div #carouselContainer class="carousel-container__items display-flex">
      <ng-container *ngIf="carouselItemTemplate">
        <ng-container *ngIf="carouselData && carouselData.length > 0">
          <div *ngFor="let data of carouselData" class="carousel-item">
            <ng-container
              *ngTemplateOutlet="
                carouselItemTemplate;
                context: { $implicit: data }
              "
            ></ng-container>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <sh-icon
    button
    icon="arrow-line-right-s"
    class="carousel-button carousel-button--right"
    tabindex="0"
    size="m"
    [disabled]="!hasItemsOnRight()"
    (click)="scrollRight()"
    onkeyup="scrollRight()"
  ></sh-icon>
</div>
